import React from 'react';
import { Box } from '@mui/material';

/**
 * Shared outer shell for the Reports tabs (Trade History, PnL History, Ledger).
 *
 * Enforces the height/overflow contract that makes "scroll only the inner
 * content, keep the pagination pinned to the bottom" actually work:
 *   - `height: 100%` + `flex: 1` + `minHeight: 0` bounds this container to
 *     whatever space its parent gives it, instead of growing with content.
 *   - `overflow: hidden` stops this container itself from scrolling, so only
 *     a bounded child (e.g. a TableContainer with `flex: 1, overflow: auto`)
 *     scrolls, leaving sibling elements like TablePagination fixed in place.
 *   - `pb: 0` avoids a gap below a bottom-pinned child like TablePagination.
 *
 * `px`/`pt` are fixed, not per-tab props: all three Reports tabs (Trade
 * History, PnL History, Ledger) share one left/right inset by design, so
 * there's only one place to change it instead of three call sites that can
 * silently drift apart (which is exactly what happened before this was
 * hardcoded here). The structural properties above are for the same reason
 * not overridable, since drifting from them is what caused this tab's
 * scroll and pagination-gap bugs.
 */
const ReportTabLayout = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      height: '100%',
      overflow: 'hidden',
      px: 0,
      pt: { xs: 0.5, sm: 1 },
      pb: 0,
      position: 'relative',
    }}
  >
    {children}
  </Box>
);

export default ReportTabLayout;
